import React from "react";
import DashboardSummary from "../../components/Report/DashboardSummary";

const ReportDashboardPage: React.FC = () => <DashboardSummary />;
export default ReportDashboardPage;
